import ScheduleTable from './ScheduleTable';
import {isDefined, isNotDefined, getFirstObjectHasProperty, namespace, parseInt10, not} from './../utils/util';
import { BREAKPOINTS, API_DOMAIN_DEFAULT, STATIC_DOMAIN_DEFAULT } from './../model/model';
import {getDatasWithOption} from "../utils/service";

(function ($, global) {
  "use strict";

  let scheduleTable = null;
  let contiGroupData = {};

  namespace('nc.lineage');

  nc.lineage.schedule = function (options) {
    if (isNotDefined(options)) throw new Error('nc.lineage.schedule require options object');

    // console.log( ' schedule.js  options : ', options );
    options.wrap.append('<div class="loadingbar"></div>');
    init();

    function init() {
      getDatasWithOption([{
        type: 'GET',
        url: options.apiDomain +'/conti/getContentGroup?service=lineage&groupAlias=lineage-schedule&subAlias=ko-KR',
        dataType: 'json',
        contentType: 'application/json',
        Accept: 'application/json'
      }], (data) => {
        if(not(Array.isArray)(data) || data.length <= 0) {
          console.log( 'error : no data' );
        } else {
          data.forEach(item => {
            if(item.alias === 'schedule-table') contiGroupData.table = JSON.parse(item.jsonData);
            if(item.alias === 'schedule-content') contiGroupData.content = JSON.parse(item.jsonData);
          });
          // console.log( ' schedule.js  contiGroupData : ', contiGroupData );
          setInstance();
        }
      }, (data) => {
        console.log( 'error : rejected' );
      });
    }

    function setInstance() {
      scheduleTable = new ScheduleTable({
        now: options.now,
        wrap: options.wrap,
        apiDomain: options.apiDomain,
        timeData: contiGroupData.table,
        timeTableData: contiGroupData.content
      }).init();
    }

  };

}(jQuery, window));



// WEBPACK FOOTER //
// ./_src/js/schedule/schedule.js